"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.cosmosBuildTransaction = void 0;
var axios_1 = __importDefault(require("axios"));
var promise_1 = require("../../promise");
var errors_1 = require("@ledgerhq/errors");
var libcore_getTransactionStatus_1 = __importDefault(require("./libcore-getTransactionStatus"));
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var bignumber_js_1 = require("bignumber.js");
var message_1 = require("./message");
var env_1 = require("../../env");
var promise_2 = require("../../promise");
var logic_1 = require("./logic");
var network_1 = __importDefault(require("../../network"));
var getBaseApiUrl = function (currency) {
    if (currency.id === "cosmos_testnet") {
        return (0, env_1.getEnv)("API_COSMOS_TESTNET_BLOCKCHAIN_EXPLORER_API_ENDPOINT");
    }
    else {
        return (0, env_1.getEnv)("API_COSMOS_BLOCKCHAIN_EXPLORER_API_ENDPOINT");
    }
};
var isStargate = function (currency) {
    if (currency.id === "cosmos_testnet") {
        return (0, env_1.getEnv)("API_COSMOS_TESTNET_NODE") == "STARGATE_NODE";
    }
    else {
        return (0, env_1.getEnv)("API_COSMOS_NODE") == "STARGATE_NODE";
    }
};
function fetch_sequence(address, currency) {
    return __awaiter(this, void 0, void 0, function () {
        var namespace, version, url, data, url, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    namespace = "cosmos";
                    version = "v1beta1";
                    if (!isStargate(currency)) return [3 /*break*/, 2];
                    url = "".concat(getBaseApiUrl(currency), "/").concat(namespace, "/auth/").concat(version, "/accounts/").concat(address);
                    return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: url
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.account.sequence];
                case 2:
                    url = "".concat(getBaseApiUrl(currency), "/auth/accounts/").concat(address);
                    return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: url
                        })];
                case 3:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.result.value.sequence];
            }
        });
    });
}
/// Return true if this address can be used to estimate gas.
/// Stargate API will refuse to estimate gas for a sender that does not
/// exist in the state, so we check the account endpoint for a non-error response
function canEstimateGas(account, transaction) {
    return __awaiter(this, void 0, void 0, function () {
        var namespace, version, url, request_1, retriable, status_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    namespace = "cosmos";
                    version = "v1beta1";
                    if (!isStargate(account.currency)) return [3 /*break*/, 3];
                    url = "".concat(getBaseApiUrl(account.currency), "/").concat(namespace, "/auth/").concat(version, "/accounts/").concat(account.freshAddress);
                    request_1 = {
                        method: "GET",
                        url: url,
                        timeout: (0, env_1.getEnv)("GET_CALLS_TIMEOUT")
                    };
                    retriable = (0, promise_1.retry)(function () { return (0, axios_1["default"])(request_1); }, {
                        maxRetry: (0, env_1.getEnv)("GET_CALLS_RETRY")
                    });
                    return [4 /*yield*/, (0, libcore_getTransactionStatus_1["default"])(account, transaction, true)];
                case 1:
                    status_1 = _a.sent();
                    return [4 /*yield*/, retriable
                            .then(function (_response) {
                            return !status_1.errors || Object.entries(status_1.errors).length === 0;
                        })["catch"](function () {
                            return false;
                        })];
                case 2: return [2 /*return*/, _a.sent()];
                case 3: return [2 /*return*/, true];
            }
        });
    });
}
function cosmosBuildTransaction(_a) {
    var account = _a.account, core = _a.core, coreAccount = _a.coreAccount, coreCurrency = _a.coreCurrency, transaction = _a.transaction, isCancelled = _a.isCancelled, isPartial = _a.isPartial;
    return __awaiter(this, void 0, void 0, function () {
        var gas, memo, cosmosLikeAccount, transactionBuilder, accountCanEstimateGas, messages, memoTransaction, estimatedGas, gasRequest, _b, gasAmount, gasPrice, feesBigNumber, feesAmount, accNum, seq, tx;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    gas = transaction.gas, memo = transaction.memo;
                    return [4 /*yield*/, coreAccount.asCosmosLikeAccount()];
                case 1:
                    cosmosLikeAccount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, cosmosLikeAccount.buildTransaction()];
                case 2:
                    transactionBuilder = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, canEstimateGas(account, transaction)];
                case 3:
                    accountCanEstimateGas = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, message_1.cosmosCreateMessage)(account.freshAddress, __assign(__assign({}, transaction), { amount: transaction.useAllAmount
                                ? (0, logic_1.getMaxEstimatedBalance)(account, new bignumber_js_1.BigNumber(0))
                                : transaction.amount }), core, account.currency)];
                case 4:
                    messages = _c.sent();
                    memoTransaction = memo || "";
                    return [4 /*yield*/, transactionBuilder.setMemo(memoTransaction)];
                case 5:
                    _c.sent();
                    if (!(isPartial && accountCanEstimateGas)) return [3 /*break*/, 9];
                    return [4 /*yield*/, core.CosmosGasLimitRequest.init(memoTransaction, messages, 
                        // COSMOS_GAS_AMPLIFIER env use by JS implementation
                        // Set as 4 int in order to not break libcore implementation
                        // String(getEnv("COSMOS_GAS_AMPLIFIER"))
                        String(4))];
                case 6:
                    gasRequest = _c.sent();
                    _b = buildBigNumber_1.libcoreBigIntToBigNumber;
                    // NOTE: With new cosmos code, this call might fail if the account hasn't been synchronized
                    // and missed a new transaction. This is because now the account sequence needs to be exact,
                    // and can't be a dummy 0 like pre-Stargate.
                    //
                    // LibCore internally calls for sequence number synchronization here, but this is a data race between the
                    // last time we read the sequence number and the instant we send the gas estimation request
                    return [4 /*yield*/, cosmosLikeAccount.estimateGas(gasRequest)];
                case 7: return [4 /*yield*/, _b.apply(void 0, [
                        // NOTE: With new cosmos code, this call might fail if the account hasn't been synchronized
                        // and missed a new transaction. This is because now the account sequence needs to be exact,
                        // and can't be a dummy 0 like pre-Stargate.
                        //
                        // LibCore internally calls for sequence number synchronization here, but this is a data race between the
                        // last time we read the sequence number and the instant we send the gas estimation request
                        _c.sent()])];
                case 8:
                    estimatedGas = _c.sent();
                    return [3 /*break*/, 10];
                case 9:
                    // 60000 is the default gas here.
                    estimatedGas = gas || new bignumber_js_1.BigNumber(60000);
                    _c.label = 10;
                case 10:
                    if (!estimatedGas.gt(0)) {
                        throw new errors_1.FeeNotLoaded();
                    }
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreAmount)(core, coreCurrency, estimatedGas)];
                case 11:
                    gasAmount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.setGas(gasAmount)];
                case 12:
                    _c.sent();
                    gasPrice = (0, env_1.getEnv)("COSMOS_GAS_PRICE");
                    feesBigNumber = estimatedGas
                        .multipliedBy(gasPrice)
                        .integerValue(bignumber_js_1.BigNumber.ROUND_CEIL);
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreAmount)(core, coreCurrency, feesBigNumber)];
                case 13:
                    feesAmount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.setFee(feesAmount)];
                case 14:
                    _c.sent();
                    if (!(transaction.useAllAmount && transaction.amount)) return [3 /*break*/, 16];
                    return [4 /*yield*/, (0, message_1.cosmosCreateMessage)(account.freshAddress, __assign(__assign({}, transaction), { amount: (0, logic_1.getMaxEstimatedBalance)(account, feesBigNumber) }), core, account.currency)];
                case 15:
                    messages = _c.sent();
                    _c.label = 16;
                case 16:
                    (0, promise_2.promiseAllBatched)(3, messages, function (message) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, transactionBuilder.addMessage(message)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); });
                    return [4 /*yield*/, cosmosLikeAccount.getAccountNumber()];
                case 17:
                    accNum = _c.sent();
                    return [4 /*yield*/, transactionBuilder.setAccountNumber(accNum)];
                case 18:
                    _c.sent();
                    if (!accountCanEstimateGas) return [3 /*break*/, 21];
                    return [4 /*yield*/, fetch_sequence(account.freshAddress, account.currency)];
                case 19:
                    seq = _c.sent();
                    return [4 /*yield*/, transactionBuilder.setSequence(seq)];
                case 20:
                    _c.sent();
                    return [3 /*break*/, 23];
                case 21: return [4 /*yield*/, transactionBuilder.setSequence("0")];
                case 22:
                    _c.sent();
                    _c.label = 23;
                case 23: return [4 /*yield*/, transactionBuilder.build()];
                case 24:
                    tx = _c.sent();
                    return [2 /*return*/, tx];
            }
        });
    });
}
exports.cosmosBuildTransaction = cosmosBuildTransaction;
exports["default"] = cosmosBuildTransaction;
//# sourceMappingURL=libcore-buildTransaction.js.map